<template>
  <div class="wai">
    <div class="curd">
      <div class="sou">
        <el-button round @click="createParentResourceFunctionDialog()">新增父资源</el-button>
      </div>
    </div>
    <div class="zhu">
      <el-collapse v-model="active">
        <el-collapse-item v-for="(allResourcelistItem,allResourcelistIndex) in allResourcelist"
          :key="allResourcelistIndex" :name="allResourcelistItem.id">
          <!-- 自定义标题模板，使用 slot 替代直接绑定 title 属性 -->
          <template #title>
            {{ allResourcelistItem.name }}(资源数量:
            <span
              style="font-weight: 700; color: #409eff;font-size: 1.2em;">{{ allResourcelistItem.list.length }}</span>)
          </template>
          <div>
            <el-button plain round type="primary"
              @click="upParentResourceFunctionDialog(allResourcelistItem)">修改父资源</el-button>
            <el-button plain round type="primary"
              @click="deParentResourceFunctionDialog(allResourcelistItem)">删除父资源</el-button>
            <el-button plain round type="success"
              @click="createChildResourceFunctionDialog(allResourcelistItem.id)">新增子资源</el-button>
          </div>
          <!-- :show-header="false" -->
          <el-table :data="allResourcelistItem.list" style="width: 100%">
            <el-table-column width="80" prop="id" label="id" />
            <el-table-column width="80" prop="main_id" label="归属" />
            <el-table-column prop="name" label="资源名称" />
            <el-table-column prop="path" label="路径" />

            <el-table-column prop="description" label="描述" />
            <el-table-column label="操作">
              <template #default="{ row }">
                <el-button type="primary" @click="upChildResourceFunctionDialog(row)" size="small">修改</el-button>
                <el-button type="primary" @click="deChildResourceFunctionDialog(row)" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-collapse-item>

      </el-collapse>
    </div>



    <el-dialog @close="dialogclose()" v-model="dialog" width="400" :close-on-click-modal="false">
      <div class="adddig">

        <!--新增父资源-->
        <div v-if="curdtype == 1">
          <div>
            <span style="font-weight: 600;font-size: 1.2em;padding: 20px;">新增父资源</span>
          </div>
          <div class="group">

            <div class="lab">
              资源名称
            </div>
            <div class="inp">
              <el-input v-model="ParentResourceParams.name" style="width: 240px" placeholder="请输入资源名称" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              资源图标
            </div>
            <div class="inp">
              <el-input v-model="ParentResourceParams.icon" style="width: 240px" placeholder="请输入资源图标url地址" />
            </div>
          </div>
          <div class="group">
            <div class="lab" style="width: 350px;display: flex;align-items: center;">
              <span style="margin:0 10px 0 0">请选择资源权限</span>
              <el-switch @change="changeSwitchF" v-model="isZongbu" class="" active-text="仅总部可用"
                inactive-text="全大区可用" />
            </div>

          </div>
          <div style="text-align: center;">
            <el-button style="width: 300px;" @click="createParentResourceFunction()">添加父角色</el-button>
          </div>
        </div>

        <!--修改父资源-->
        <div v-if="curdtype == 2">
          <div>
            <span style="font-weight: 600;font-size: 1.2em;padding: 20px;">修改父资源信息</span>
          </div>
          <div class="group">

            <div class="lab">
              资源名称
            </div>
            <div class="inp">
              <el-input v-model="ParentResourceParams.name" style="width: 240px" placeholder="请输入资源名称" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              资源图标
            </div>
            <div class="inp">
              <el-input v-model="ParentResourceParams.icon" style="width: 240px" placeholder="请输入资源图标url地址" />
            </div>
          </div>
          <div class="group">
            <div class="lab" style="width: 350px;display: flex;align-items: center;">
              <span style="margin:0 10px 0 0">请选择资源权限</span>
              <el-switch @change="changeSwitch" v-model="isZongbu" active-text="仅总部可用" inactive-text="全大区可用" />
            </div>

          </div>
          <div style="text-align: center;">
            <el-button style="width: 300px;" @click="upParentResourceFunction()">确认修改父资源信息</el-button>
          </div>
        </div>
        <!--删除父资源-->
        <div v-if="curdtype == 3">
          <div>
            <span style="font-weight: 600;font-size: 1.2em;padding: 20px;">删除该父亲资源</span>
          </div>
          <div>
            <span style="font-weight: 600;padding: 20px;color:#CC1862">资源I D :{{ParentResourceParams.id}}</span>
            <br />
            <span style="font-weight: 600;padding: 20px;color:#DE6978">资源名称:{{ParentResourceParams.name}}</span>
          </div>
          <div style="display: flex;justify-content: center;padding: 20px;">
            <el-button type="info" @click="dialog = false ">取消操作</el-button>
            <el-button type="danger" @click="deParentResourceFunction">确认删除</el-button>
          </div>

        </div>

        <div v-if="curdtype == 4">
          <div>
            <span style="font-weight: 600;font-size: 1.2em;padding: 20px;">新增子资源</span>
          </div>
          <div class="group">

            <div class="lab">
              资源名称
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.name" style="width: 240px" placeholder="请输入资源名称" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              资源图标
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.icon" style="width: 240px" placeholder="请输入资源图标url地址" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              资源路径
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.path" style="width: 240px" placeholder="请输入资源路径" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              资源描述
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.description" style="width: 240px" placeholder="请输入资源描述" />
            </div>
          </div>
          <div class="group">
            <div class="lab" style="width: 350px;display: flex;align-items: center;">
              <span style="margin:0 10px 0 0">请选择资源权限</span>
              <el-switch @change="changeSwitchZ" v-model="isZongbu" class="" active-text="仅总部可用"
                inactive-text="全大区可用" />
            </div>

          </div>
          <div style="text-align: center;">
            <el-button style="width: 300px;" @click="createChildResourceFunction">添加子资源</el-button>
          </div>
        </div>
        <div v-if="curdtype == 5">
          <div>
            <span style="font-weight: 600;font-size: 1.2em;padding: 20px;">修改子资源</span>
          </div>

          <div class="group">
            <div class="lab">
              资源归属
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.main_id" disabled style="width: 240px" placeholder="请输入资源名称" />
            </div>
          </div>
          <div class="group">

            <div class="lab">
              资源名称
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.name" style="width: 240px" placeholder="请输入资源名称" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              资源图标
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.icon" style="width: 240px" placeholder="请输入资源图标url地址" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              资源路径
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.path" style="width: 240px" placeholder="请输入资源路径" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              资源描述
            </div>
            <div class="inp">
              <el-input v-model="ChildResourceParams.description" style="width: 240px" placeholder="请输入资源描述" />
            </div>
          </div>
          <div class="group">
            <div class="lab" style="width: 350px;display: flex;align-items: center;">
              <span style="margin:0 10px 0 0">请选择资源权限</span>
              <el-switch @change="changeSwitchZ" v-model="ChildResourStatus" class="" active-text="仅总部可用"
                inactive-text="全大区可用" />
            </div>

          </div>
          <div style="text-align: center;">
            <el-button style="width: 300px;" @click="upChildResourceFunction">修改子资源</el-button>
          </div>
        </div>


        <!--删除父资源-->
        <div v-if="curdtype == 6">
          <div>
            <span style="font-weight: 600;font-size: 1.2em;padding: 20px;">删除该子亲资源</span>
          </div>
          <div>
            <span style="font-weight: 600;padding: 20px;color:#CC1862">资源I D :{{ChildResourceParams.id}}</span>
            <br />
            <span style="font-weight: 600;padding: 20px;color:#DE6978">资源名称:{{ChildResourceParams.name}}</span>
          </div>
          <div style="display: flex;justify-content: center;padding: 20px;">
            <el-button type="info" @click="dialog = false ">取消操作</el-button>
            <el-button type="danger" @click="deChildResourceFunction">确认删除</el-button>
          </div>

        </div>

      </div>
    </el-dialog>

  </div>
</template>

<script setup>
  import {
    ElMessage
  } from 'element-plus';
  import {
    onMounted,
    reactive,
    ref
  } from 'vue';
  import {
    getAllDepartmentResourceList, //获取全部资源列表
    createParentResource, //创建父资源
    deParentResource, //删除父资源
    upParentResource, //更新修改父资源
    createChildResource, //创建子资源
    deChildResource, //删除子资源
    upChildResource, //更新修改子资源
  } from '@/api/api'
  onMounted(() => {
    getDepartmentListFunction()
  })
  const dialog = ref(false)
  /**
   * @param curdtype
   * 定义弹出面板的变量
   * 1 => 新增父资源
   * 2 => 更新父资源
   * 3 => 删除父资源
   * 4 => 新增子资源
   * 5 => 更新子资源
   * 6 => 删除子资源
   **/
  const curdtype = ref(1)

  //折叠面板的
  const active = ref([])

  const isZongbu = ref(false)
  const ChildResourStatus = ref(false)

  //获取全部资源列表
  const allResourcelist = ref()
  const getDepartmentListFunction = async () => {

    const res = await getAllDepartmentResourceList()
    if (res.code == 200) {
      allResourcelist.value = res.data.list
    } else {
      ElMessage.error(res.message)
    }
  }

  const ParentResourceParams = reactive({
    id: '',
    name: '',
    type: 1,
    icon: ''
  });
  //新增父资源
  const createParentResourceFunction = async () => {
    if (ParentResourceParams.name == '' || ParentResourceParams.name.length < 2) {
      ElMessage.error('请输入需要新增的父资源名称(可能为父资源名称过短)')
    }
    const data = {
      name: ParentResourceParams.name,
      type: ParentResourceParams.type,
      icon: ParentResourceParams.icon,

    }
    const res = await createParentResource(data)
    if (res.code == 200) {
      ElMessage.success(res.message)
      dialog.value = false
      getDepartmentListFunction()
    } else {
      ElMessage.error(res.message)
    }
  }
  //更新修改父资源
  const upParentResourceFunction = async () => {
    if (ParentResourceParams.id == '' || ParentResourceParams.id < 1) {
      ElMessage.error('更新参数有误！')
    }
    const data = {
      id: ParentResourceParams.id,
      name: ParentResourceParams.name,
      icon: ParentResourceParams.icon,
      type: ParentResourceParams.type
    }
    const res = await upParentResource(data)
    if (res.code == 200) {
      ElMessage.success(res.message)
      dialog.value = false
      getDepartmentListFunction()
    } else {
      ElMessage.error(res.message)
    }
  }

  //删除父资源
  const deParentResourceFunction = async () => {
    if (ParentResourceParams.id == '' || ParentResourceParams.id < 1) {
      ElMessage.error('更新参数有误！')
    }
    const data = {
      id: ParentResourceParams.id
    }
    const res = await deParentResource(data)
    if (res.code == 200) {
      ElMessage.success(res.message)
      dialog.value = false
      getDepartmentListFunction()
    } else {
      ElMessage.error(res.message)
    }
  }


  const ChildResourceParams = reactive({
    id: '',
    main_id: '',
    name: '',
    status: 1,
    icon: '',
    description: '',
    path: ''
  });

  //创建子资源
  const createChildResourceFunction = async () => {

    if (ChildResourceParams.name == '' || ChildResourceParams.main_id < 1 || ChildResourceParams.path == '') {
      console.log(ChildResourceParams);
      ElMessage.error('请填写必要参数')
      return
    }
    const data = {
      id: ChildResourceParams.main_id,
      name: ChildResourceParams.name,
      icon: ChildResourceParams.icon,
      status: ChildResourceParams.status,
      description: ChildResourceParams.description,
      path: ChildResourceParams.path
    }
    const res = await createChildResource(data)
    if (res.code == 200) {
      ElMessage.success(res.message)
      dialog.value = false
      getDepartmentListFunction()
    } else {
      ElMessage.error(res.message)
    }
  }

  //更新修改子资源
  const upChildResourceFunction = async () => {

    if (ChildResourceParams.name == '' || ChildResourceParams.main_id < 1 || ChildResourceParams.path == '') {
      console.log(ChildResourceParams);
      ElMessage.error('请填写必要参数')
      return
    }
    const data = {
      id: ChildResourceParams.id,
      main_id: ChildResourceParams.main_id,
      name: ChildResourceParams.name,
      icon: ChildResourceParams.icon,
      status: ChildResourceParams.status,
      description: ChildResourceParams.description,
      path: ChildResourceParams.path
    }

    const res = await upChildResource(data)
    if (res.code == 200) {
      ElMessage.success(res.message)
      dialog.value = false
      getDepartmentListFunction()
    } else {
      ElMessage.error(res.message)
    }
  }
  //删除子资源
  const deChildResourceFunction = async () => {
    const data = {
      id: ChildResourceParams.id,
    }
    const res = await deChildResource(data)
    if (res.code == 200) {
      ElMessage.success(res.message)
      dialog.value = false
      getDepartmentListFunction()
    } else {
      ElMessage.error(res.message)
    }
  }



  //打开父资源创建窗口
  const createParentResourceFunctionDialog = (item) => {

    curdtype.value = 1
    dialog.value = true
  }
  //打开父资源修改窗口
  const upParentResourceFunctionDialog = (item) => {
    ParentResourceParams.id = item.id
    ParentResourceParams.name = item.name
    ParentResourceParams.icon = item.icon
    ParentResourceParams.type = item.type
    if (ParentResourceParams.type == 0) {

      isZongbu.value = true
    } else {

      isZongbu.value = false
    }
    curdtype.value = 2
    dialog.value = true
  }
  //打开父资源删除窗口
  const deParentResourceFunctionDialog = (item) => {
    ParentResourceParams.id = item.id
    ParentResourceParams.name = item.name
    curdtype.value = 3
    dialog.value = true
  }

  //switch 开关状态

  const changeSwitchF = (item) => {

    if (item == true) {
      ParentResourceParams.type = 0
    } else {
      ParentResourceParams.type = 1
    }

  }

  //switch 开关状态

  const changeSwitchZ = (item) => {

    if (item == true) {
      ChildResourceParams.status = 0
    } else {
      ChildResourceParams.status = 1
    }

  }

  //打开子资源创建窗口
  const createChildResourceFunctionDialog = (item) => {
    ChildResourceParams.main_id = item //父资源的ID
    curdtype.value = 4
    dialog.value = true
  }
  //打开子资源修改窗口
  const upChildResourceFunctionDialog = (item) => {
    ChildResourceParams.id = item.id
    ChildResourceParams.main_id = item.main_id
    ChildResourceParams.name = item.name
    ChildResourceParams.icon = item.icon
    ChildResourceParams.path = item.path
    ChildResourceParams.status = item.status
    ChildResourceParams.description = item.description
    if (ChildResourceParams.status == 0) {
      ChildResourStatus.value = true
    } else {
      ChildResourStatus.value = false
    }
    curdtype.value = 5
    dialog.value = true
  }

  //打开子资源删除窗口
  const deChildResourceFunctionDialog = (item) => {
    ChildResourceParams.name = item.name
    ChildResourceParams.main_id = item.main_id
    ChildResourceParams.id = item.id
    curdtype.value = 6
    dialog.value = true
  }















  const addjuese = async () => {
    if (rolename.value == "" || rolename.value == null) {
      ElMessage.error("角色名称不能为空！")
      return
    }
    const data = {
      name: rolename.value,
      department_id: did.value,
      description: roleeg.value
    }
    const res = await addrole(data)
    if (res.code == 200) {
      ElMessage.success("角色添加成功")
    } else {
      ElMessage.error(res.message)
    }
    getDepartmentListFunction()
    dialog.value = false
  }
  const updjuese = async () => {
    const data = {
      role_id: rid.value,
      name: rolename.value,
      description: roleeg.value
    }
    const res = await updrole(data)
    if (res.code == 200) {
      ElMessage.success("角色修改成功")
    } else {
      ElMessage.error(res.message)
    }
    getDepartmentListFunction()
    dialog.value = false
  }
  const deljuese = async () => {
    const data = {
      role_id: rid.value
    }
    const res = await delrole(data)
    if (res.code == 200) {
      ElMessage.success("角色删除成功")
    } else {
      ElMessage.error(res.message)
    }
    getDepartmentListFunction()
    dialog.value = false
  }
  const add = (id) => {
    curdtype.value = 1
    did.value = id
    dialog.value = true
  }
  const upd = (row) => {
    curdtype.value = 2
    rid.value = row.id
    oldname.value = row.name
    roleeg.value = row.description
    dialog.value = true
  }
  const del = (row) => {
    oldname.value = row.name
    rid.value = row.id
    curdtype.value = 3
    dialog.value = true
  }

  const dialogclose = () => {
    curdtype.value = 1
    ParentResourceParams.name = ''
    ParentResourceParams.icon = ''
    ParentResourceParams.type = 1
    ParentResourceParams.id = ''
    ChildResourceParams.id = ''
    ChildResourceParams.main_id = ''
    ChildResourceParams.name = ''
    ChildResourceParams.icon = ''
    ChildResourceParams.path = ''
    ChildResourceParams.status = 1
    ChildResourceParams.description = ''





  }
</script>

<style lang="scss" scoped>
  .wai {
    width: 100%;
    height: 100%;
    padding: 0 20px;


    .curd {
      height: 50px;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .zhu {
      width: 100%;
      height: calc(100% - 45px - 50px);
      overflow-y: auto;
      border-radius: 10px;

      .biao {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .tou {
          font-weight: bolder;
          color: #000;
          height: 40px;
          background-color: #dddddd;
        }

        .shen {
          height: 40px;
          color: #000;
          text-align: center;
          font-size: 16px;
        }

        .shen:nth-child(odd) {
          background-color: #F5F7FA;
        }
      }
    }

    .page {
      height: 45px;
      width: 100%;
      display: flex;
      padding: 0 30px;
      justify-content: right;
    }
  }

  .adddig {
    .group {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      padding: 10px 0px;

      .lab {
        padding-left: 20px;
        width: 130px;
      }
    }
  }
</style>
